export default "__VITE_ASSET__29b97db0__"